<template>
  <div
    :id="`title-${dynamicNumber}`"
    class="spotify-podcast"
    :class="[content.mobile_settings, content.align]"
    :style="`color : ${customDescColor};background : ${customColor}; ${customGradient}; `"
  >
    <div
      class="spotify-podcast__container"
      :class="[content.horizontal_margin, content.vertical_margin,content.horizontal_align]"
      :style="`width: ${customWidth}`"
      data-nosnippet
    >
      <iframe
        data-testid="embed-iframe"
        style="border-radius:12px"
        :src="content.podcast_src"
        width="100%"
        height="352"
        frameBorder="0"
        allowfullscreen=""
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script>
/* Mixins */
import marked from "@/mixins/marked";

export default {
  mixins: [marked],
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    isProject: {
      type: Boolean
    }
  },

  computed: {
    dynamicNumber() {
      const randomNum = Math.floor(1000 + Math.random() * 9000);
      return randomNum;
    },

    customColor() {
      if (this.content.bg_color) {
        return this.content.bg_color;
      } else {
        return "transparent";
      }
    },

    customGradient() {
      if (this.content.gradient_code) {
        return this.content.gradient_code;
      } else {
        return "";
      }
    },

    customDescColor() {
      if (this.content.color) {
        return this.content.color;
      } else {
        return "#000";
      }
    },

    customWidth() {
      if (this.$store.state.isMobile) {
        return "100%";
      } else {
        return this.content.width + "%";
      }
    },
  },
};
</script>

<style lang="scss">
.spotify-podcast {
  display: flex;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;
  @include paddingMobile;


  &.left {
    justify-content: flex-start;
  }

  &.center {
    justify-content: center;
  }

  &.right {
    justify-content: flex-end;
  }

  .hide {
    display: none;
  }




  &.hide-mobile {
    display: none;

    @include tablet {
      display: block;
    }

  }

  &__container {
      &.super {
        @include paddingSuper;
      }

      &.big {
        @include paddingBig;
      }

      &.standard {
        @include paddingMedium;
      }

      &.small {
        @include paddingSmall;
      }

      &.bottom-text {
        @include paddingMobileBottom;

        @include tablet {
          @include paddingBottomSmall;
        }
      }

      &.bottom-standard {
        @include paddingMobileBottom;

        @include tablet {
          @include paddingBottom;
        }
      }

      &.bottom-big {
        @include paddingMobileBottom;

        @include tablet {
          @include paddingBottomBig;
        }
      }

      &.bottom-super-big {
        @include paddingMobileBottom;

        @include tablet {
          @include paddingBottomSuper;
        }
      }

      &.bottom-small {
        @include paddingMobileBottom;

        @include tablet {
          @include paddingBottomSmallProject;
        }
      }

  }



}
</style>
